import React from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";

//采购报表
export default () => {
    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    )
}